import { Box, Grid, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import React from "react";
import CustomNoRowsOverlay from "../../../../newComponent/TableCustomeComp/CustomNoRowsOverlay";
import { fDateTime, useDateUtils } from "../../../../../utils/formatTime";

export default function CampaignWiseDetailsReport({
  detailsData,
  rowData,
  filterType,
  fromDate,
  toDate,
}) {
  const userRole = localStorage.getItem("userRole");
  const { currentMonthName, lastMonthName, weekRange, currentYear } =
    useDateUtils();
  let currentDate = new Date().toISOString().split("T")[0];

  const columns = [
    {
      field: "name",
      headerName: "Name",
      width: 150,
      valueGetter: (params) =>
        `${params.row?.first_name || ""} ${params.row?.last_name || ""}`,
      renderCell: (params) => (
        <div>
          {params.row?.first_name} {params.row?.last_name}
        </div>
      ),
    },

    {
      field: "mobile",
      headerName: "Mobile",
      width: 150,
      valueGetter: (params) =>
        ` ${params.row?.mobile_country_code} ${params.row?.mobile || ""}`,
      renderCell: (params) => (
        <div>
          {params.row?.mobile_country_code}
          {params.row?.mobile}
        </div>
      ),
    },
    {
      field: "email",
      headerName: "Email ID",
      width: 220,
    },
    {
      field: "enquired_service",
      headerName: "Enquired Service",
      width: 170,
      valueGetter: (params) => `${params.row?.service_id?.service_name || ""}`,
      renderCell: (params) => <div>{params.row.service_id?.service_name}</div>,
    },

    {
      field: "sub_service_id",
      headerName: "Sub Service",
      width: 250,
      valueGetter: (params) => `${params.row?.sub_service_id?.name || ""}`,
      renderCell: (params) => <div>{params.row.sub_service_id?.name}</div>,
    },
    {
      field: "branch_id",
      headerName: "STM Nearest Branch",
      width: 200,
      valueGetter: (params) =>
        `${params.row?.nearest_branch_id?.branch_name || ""}`,
      renderCell: (params) => (
        <div>{params.row.nearest_branch_id?.branch_name} </div>
      ),
    },
    {
      field: "permanent_assignee",
      headerName: "Permanent Assignee",
      width: 150,
      valueGetter: (params) =>
        `${params.row?.enquiry_id?.assign_to?.first_name || ""} ${
          params.row?.enquiry_id?.assign_to?.last_name || ""
        }`,
      renderCell: (params) => (
        <div>
          {params.row.enquiry_id?.assign_to?.first_name} {params.row.enquiry_id?.assign_to?.last_name}
        </div>
      ),
    },

    {
      field: "lead_source_type_id",
      headerName: "Lead Source",
      width: 150,
      valueGetter: (params) => `${params.row?.lead_source_type_id?.name || ""}`,
      renderCell: (params) => (
        <div>{params.row.lead_source_type_id?.name} </div>
      ),
    },
    {
      field: "sub_lead_source_type_name",
      headerName: "Sub Lead Source",
      width: 150,
      valueGetter: (params) =>
        `${params.row?.sub_lead_source_type_id?.source_type || ""}`,
      renderCell: (params) => (
        <div>{params.row?.sub_lead_source_type_id?.source_type} </div>
      ),
    },

    {
      field: "facebook_campaign_id",
      headerName: "Facebook Campaign",
      width: 250,
      valueGetter: (params) => `${params.row?.facebook_campaign_name || ""}`,
      renderCell: (params) => <div>{params.row?.facebook_campaign_name} </div>,
    },

    {
      field: "campaign_id",
      headerName: "Stm Campaign",
      width: 350,
      valueGetter: (params) =>
        `${params.row?.campaign_id?.campaign_name || ""}`,
      renderCell: (params) => (
        <div>{params.row?.campaign_id?.campaign_name} </div>
      ),
    },

    {
      field: "first_country",
      headerName: "First Country Of Interest",
      width: 150,
      valueGetter: (params) =>
        `${params.row?.target_country_id?.country_name || ""}`,
      renderCell: (params) => (
        <div>{params.row.target_country_id?.country_name} </div>
      ),
    },

    {
      field: "created_time",
      headerName: "Created Time",
      width: 150,
      valueGetter: (params) => `${params.row?.createdAt || ""}`,
      renderCell: (params) => <div>{fDateTime(params.row?.createdAt)} </div>,
    },
  ];
  return (
    <>
      <Grid container spacing={2}>
          <Grid
                  item
                  xs={12}
                  md={9}
                  sx={{ display: "flex", flexDirection: "row", gap: 5 }}
                >
                
                    <Box sx={{ display: "flex", flexDirection: "row" }}>
                      <Typography variant="h5"> Facebook Campaign :</Typography>
                      <Typography ml={1}>
                        {rowData?.name} 
                      </Typography>
                    </Box>
            
                  <Box sx={{ display: "flex", flexDirection: "row" }}>
                    <Typography variant="h5" mr={1}>Enquiry Created Date :</Typography>
        
        
        
                    {filterType === "today" && (
                      <Typography>Today ({currentDate})</Typography>
                    )}
                    {filterType === "currentweek" && (
                      <Typography>This Week ({weekRange})</Typography>
                    )}
        
                    {filterType === "currentmonth" && (
                      <Typography>
                        {currentMonthName} {currentYear}
                      </Typography>
                    )}
        
                    {filterType === "custom" && (
                      <Typography>
                        {fromDate} - {toDate}
                      </Typography>
                    )}
                  </Box>
                </Grid>
        <Grid item xs={12}>
          <DataGrid
            rows={detailsData}
            columns={columns}
            autoHeight
            slots={{
              noRowsOverlay: CustomNoRowsOverlay,
            }}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 25,
                },
              },
            }}
            pageSizeOptions={[25, 50, 100]}
          />
        </Grid>
      </Grid>
    </>
  );
}
